import actions from "./actions";
import Big from 'big.js';

const initState = {
    createState: null,
    createResult: {},
    readListState: null,
    reconciliations: [],
    readState: null,
    reconciliation: {
        id: null,
        account_id: null,
        date: null,
        opening_balance: null,
        closing_balance: null,
        mode: null,
        is_balanced: true,
        is_locked: false, // to remove?
        ledgers: [],
        statement_lines: [],
    },
    ledgers: [],
    statementLines: [],
    mode: null,
    date: null,
    openingBalance: 0,
    closingBalance: 0,
    reconciledBalance: 0,
    differenceAmount: 0,
    updateState: null,
    deleteState: null,
    createTransactionState: null,
    createTransactionResult: {},
    // readTransactionsState: null,
    id: null,
    selectedRowKeys: [],
    selectedRows: [],
    activeTabKey: null,
    updatedLines: [],
    activeStatementLine: false,
    activeStatementLineType: null,
    filterState: {
        transactionType: null,
        dateRange: [null, null],
    },
};
let closingBalanceB, reconciledBalanceB, differenceAmountB, statementLineAmountB;
let idx, line, reconciliation, statementLines, statementLine, indices, objAmount;
let updatedLines;

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.RECONCILIATION_CREATE_REQUEST:
            return {
                ...state,
                createState: 'request',
            };
        case actions.RECONCILIATION_CREATE_SUCCESS:
            return {
                ...state,
                createState: 'success',
                createResult: action.reconciliation,
            };
        case actions.RECONCILIATION_READ_LIST_REQUEST:
            return {
                ...state,
                readAllState: 'request',
            };
        case actions.RECONCILIATION_READ_LIST_SUCCESS:
            return {
                ...state,
                readAllState: 'success',
                reconciliations: action.reconciliations,
            };
        case actions.RECONCILIATION_READ_REQUEST:
            return {
                ...state,
                readState: 'request',
            };
        case actions.RECONCILIATION_READ_SUCCESS: // {id} or new
            closingBalanceB = new Big(action.reconciliation.closing_balance || 0);
            reconciledBalanceB = new Big(action.reconciliation.opening_balance);

            switch (action.reconciliation.mode) {
                case 'statement':
                    if (action.reconciliation.statement_lines !== null) {
                        action.reconciliation.statement_lines.forEach(item => {
                            if (item.ledger_id)
                                reconciledBalanceB = reconciledBalanceB.plus(item.amount);
                        });
                    }
                    break;
                case 'manual': default:
                    action.reconciliation.ledgers.forEach(item => {
                        if (item.is_selected || state.selectedRowKeys.includes(item.id))
                            reconciledBalanceB = reconciledBalanceB.plus(item.amount);
                    });
                    break;
            }
            differenceAmountB = closingBalanceB.minus(reconciledBalanceB);

            return {
                ...state,
                readState: 'success',
                reconciliation: action.reconciliation,
                ledgers: action.reconciliation.ledgers,
                statementLines: action.reconciliation.statement_lines || state.statementLines,
                mode: action.reconciliation.mode,
                date: action.reconciliation.date,
                openingBalance: action.reconciliation.opening_balance,
                closingBalance: action.reconciliation.closing_balance,
                reconciledBalance: parseFloat(reconciledBalanceB),
                differenceAmount: parseFloat(differenceAmountB),
            };
        case actions.RECONCILIATION_UPDATE_REQUEST:
            return {
                ...state,
                updateState: 'request',
            };
        case actions.RECONCILIATION_UPDATE_SUCCESS:
            closingBalanceB = new Big(action.reconciliation.closing_balance || 0);
            reconciledBalanceB = new Big(action.reconciliation.opening_balance);
            action.reconciliation.ledgers.forEach(item => {
                if (item.is_selected)
                    reconciledBalanceB = reconciledBalanceB.plus(item.amount);
            });
            differenceAmountB = closingBalanceB.minus(reconciledBalanceB);

            return {
                ...state,
                updateState: 'success',
                reconciliation: action.reconciliation,
                ledgers: action.reconciliation.ledgers,
                statementLines: action.reconciliation.statement_lines,
                mode: action.reconciliation.mode,
                date: action.reconciliation.date,
                openingBalance: action.reconciliation.opening_balance,
                closingBalance: action.reconciliation.closing_balance,
                reconciledBalance: parseFloat(reconciledBalanceB),
                differenceAmount: parseFloat(differenceAmountB),
            };
        case actions.RECONCILIATION_DELETE_REQUEST:
            return {
                ...state,
                deleteState: 'request',
            };
        case actions.RECONCILIATION_DELETE_SUCCESS:
            return {
                ...state,
                deleteState: 'success',
            };
        case actions.RECONCILIATION_CREATE_TRANSACTION_REQUEST:
            return {
                ...state,
                createTransactionState: 'request',
            };
        case actions.RECONCILIATION_CREATE_TRANSACTION_SUCCESS:
            return {
                ...state,
                createTransactionState: 'success',
                createTransactionResult: action.ledger,
            };
        case actions.RECONCILIATION_ADD_LEDGER: {
            let newLedgers = [
                ...state.ledgers,
            ];

            // specified an index to insert to
            if (!(action.index === null || action.index === undefined)) {
                newLedgers.splice(action.index, 0, action.ledger);
            }
            else {
                // Add to the end of the list
                newLedgers = [
                    ...state.ledgers,
                    action.ledger,
                ];
            }

            return {
                ...state,
                ledgers: newLedgers,
            };
        }
        case actions.RECONCILIATION_SET_LEDGER: {
            const newLedgers = [
                ...state.ledgers,
            ];
            const currentLedgerIdx = newLedgers.findIndex(l => l.id === action.ledger.id);

            // specified an index to insert to
            if (!(currentLedgerIdx === null || currentLedgerIdx === undefined))
                newLedgers.splice(currentLedgerIdx, 1, action.ledger);

            return {
                ...state,
                ledgers: newLedgers,
            };
        }
        // case actions.RECONCILIATION_READ_TRANSACTIONS_REQUEST:
        //   return {
        //     ...state,
        //     readTransactionsState: 'request',
        //   };
        // case actions.RECONCILIATION_READ_TRANSACTIONS_SUCCESS:
        //   return {
        //     ...state,
        //     readTransactionsState: 'success',
        //     transactions: action.transactions,
        //   };
        case actions.RECONCILIATION_SET:
            reconciliation = {
                ...state.reconciliation,
                ...action.reconciliation,
            };

            return {
                ...state,
                reconciliation,
                ledgers: reconciliation.ledgers,
                statementLines: reconciliation.statement_lines,
                mode: reconciliation.mode,
                date: reconciliation.date,
                openingBalance: reconciliation.opening_balance,
                closingBalance: reconciliation.closing_balance,
                reconciledBalance: reconciliation.opening_balance,
                differenceAmount: 0,
            };
        case actions.RECONCILIATION_SET_MODE:
            return {
                ...state,
                mode: action.mode,
            };
        case actions.RECONCILIATION_SET_ID:
            return {
                ...state,
                id: action.id,
            };
        case actions.RECONCILIATION_SET_DATE:
            return {
                ...state,
                date: action.date,
            };
        case actions.RECONCILIATION_SET_CLOSING_BALANCE:
            closingBalanceB = new Big(action.closingBalance || 0);
            differenceAmountB = closingBalanceB.minus(state.reconciledBalance);

            return {
                ...state,
                closingBalance: action.closingBalance || 0,
                differenceAmount: parseFloat(differenceAmountB),
            };
        case actions.RECONCILIATION_SET_RECONCILED_BALANCE:
            closingBalanceB = new Big(state.closingBalance || 0);
            differenceAmountB = closingBalanceB.minus(action.reconciledBalance);

            return {
                ...state,
                reconciledBalance: action.reconciledBalance,
                differenceAmount: parseFloat(differenceAmountB),
            };
        case actions.RECONCILIATION_SET_SELECTED_ROW_KEYS:
            return {
                ...state,
                selectedRowKeys: action.selectedRowKeys,
            };
        case actions.RECONCILIATION_SET_SELECTED_ROWS:
            return {
                ...state,
                selectedRows: action.selectedRows,
            };
        case actions.RECONCILIATION_SET_ACTIVE_TAB_KEY:
            return {
                ...state,
                activeTabKey: action.activeTabKey,
            };
        case actions.RECONCILIATION_ADD_STATEMENT_LINE: // Add to the end of the list
            return {
                ...state,
                statementLines: [
                    ...state.statementLines,
                    action.statementLine,
                ],
            };
        case actions.RECONCILIATION_SET_STATEMENT_LINE: // Support partial update (Must have line)
            statementLines = [...state.statementLines];
            idx = statementLines.findIndex(item => item.line === action.statementLine.line);

            // Merge the item
            statementLine = {
                ...statementLines[idx],
                ...action.statementLine,
            };
            statementLines[idx] = statementLine;

            return {
                ...state,
                statementLines,
            };
        case actions.RECONCILIATION_SET_STATEMENT_LINES: // Update entire list.
            line = 1;
            statementLines = [...action.statementLines];
            statementLines.forEach((item, itemIdx) => {
                line += 1;
                statementLines[itemIdx].line = line;
            });

            return {
                ...state,
                statementLines,
            };
        case actions.RECONCILIATION_SPLIT_STATEMENT_LINE: { // Split line into two.
            const { amounts } = action;
            statementLines = [...state.statementLines];
            idx = statementLines.findIndex(item => item.line === action.statementLine.line);

            // Negate amounts
            statementLineAmountB = new Big(action.statementLine.amount);
            amounts.forEach((item, itemIdx) => {
                if (statementLineAmountB.lt(0))
                    amounts[itemIdx] = -amounts[itemIdx];
            });

            // Update statement line: Update amount & clear selected ledger record.
            statementLine = statementLines[idx];
            statementLine.amount = amounts[0];
            statementLine.ledger_id = null;
            statementLine.adjust_exchange_rate = null;
            statementLine.adjust_amount = null;
            statementLine.adjust_account_id = null;

            // Updated lines
            updatedLines = [idx];

            // Merge back
            statementLines[idx] = statementLine;

            // New lines
            for (let i = 1; i < amounts.length; i += 1) {
                statementLines.splice(idx + i, 0, {
                    line: null,
                    date: statementLine.date,
                    amount: amounts[i],
                    description: statementLine.description,
                });
                updatedLines.push(idx + i);
            }

            // Reorder line
            statementLines = statementLines.map((item, idx) => ({
                ...item,
                line: idx + 1,
            }));

            return {
                ...state,
                statementLines,
                updatedLines,
            };
        }
        case actions.RECONCILIATION_MERGE_STATEMENT_LINES: // Merge lines
            statementLines = [...state.statementLines];
            indices = [];
            statementLines.forEach((item, itemIdx) => {
                if (action.lines.includes(item.line))
                    indices.push(itemIdx);
            });

            // Compute sum
            statementLineAmountB = new Big(0);
            indices.forEach(item => {
                statementLineAmountB = statementLineAmountB.plus(statementLines[item].amount);
            });

            // Update first statement line: Update amount.
            statementLine = statementLines[indices[0]];
            statementLine.amount = statementLineAmountB.toFixed(2);
            statementLine.description = action.description;
            // Unselect ledger & remove adjust info.
            statementLine.ledger_id = null;
            statementLine.adjust_exchange_rate = null;
            statementLine.adjust_amount = null;
            statementLine.adjust_account_id = null;

            // Updated lines
            updatedLines = [indices[0]];

            // Delete other lines (reverse)
            indices.splice(0, 1); // remove first one.
            for (idx = indices.length - 1; idx >= 0; idx -= 1)
                statementLines.splice(indices[idx], 1);

            // Reorder line
            line = 1;
            statementLines = statementLines.map((item, idx) => ({
                ...item,
                line: idx + 1,
            }));

            return {
                ...state,
                statementLines,
                updatedLines,
            };
        case actions.RECONCILIATION_REMOVE_STATEMENT_LINES: // Delete lines from the list
            statementLines = [...state.statementLines];
            indices = [];
            statementLines.forEach((item, itemIdx) => {
                if (action.lines.includes(item.line))
                    indices.push(itemIdx);
            });

            // Delete lines (reverse)
            objAmount = new Big(0);
            for (let i = indices.length - 1; i >= 0; i -= 1) {
                objAmount = objAmount.minus(statementLines[indices[i]].amount);
                statementLines.splice(indices[i], 1);
            }

            // Reorder line
            line = 1;
            statementLines = statementLines.map((item, idx) => ({
                ...item,
                line: idx + 1,
            }));

            // Update closing balance & difference.
            closingBalanceB = objAmount.plus(state.closingBalance);
            differenceAmountB = closingBalanceB.minus(state.reconciledBalance);

            return {
                ...state,
                statementLines,
                closingBalance: parseFloat(closingBalanceB),
                differenceAmount: parseFloat(differenceAmountB),
            };
        case actions.RECONCILIATION_SET_ACTIVE_STATEMENT_LINE:
            return {
                ...state,
                activeStatementLine: action.line,
                activeStatementLineType: action.lineType,
            };
        case actions.RECONCILIATION_CLEAR_UPDATED_LINES:
            return {
                ...state,
                updatedLines: [],
            };
        case actions.RECONCILIATION_RESET:
            return initState;

        case actions.RECONCILIATION_SET_FILTER_STATE:
            return {
                ...state,
                filterState: action.filterState,
            };
        default:
            return state;
    }
}
